export const UNINITIALIZED = 'UNINITIALIZED';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const requestStatuses = {
  FAILED: 'FAILED',
  STARTED: 'STARTED',
  SUCCEEDED: 'SUCCEEDED',
  UNINITIALIZED: 'UNINITIALIZED'
};